import { create } from 'zustand'

type SceneState = {
  cubeModelLoaded: boolean
  cubeModelError: boolean
  /** 立方体接近 DropBox 的归一化强度 0..1（1 = 在触发半径内） */
  dropProximity: number

  setCubeModelLoaded: (b: boolean) => void
  setCubeModelError: (b: boolean) => void
  setDropProximity: (p: number) => void
}

export const useSceneStore = create<SceneState>((set) => ({
  cubeModelLoaded: false,
  cubeModelError: false,
  dropProximity: 0,
  setCubeModelLoaded: (b) => set({ cubeModelLoaded: b }),
  setCubeModelError: (b) => set({ cubeModelError: b }),
  setDropProximity: (p) => set({ dropProximity: p }),
}))
